import script from "./CoveredCallNew.vue?vue&type=script&setup=true&lang=js"
export * from "./CoveredCallNew.vue?vue&type=script&setup=true&lang=js"

import "./CoveredCallNew.vue?vue&type=style&index=0&id=21bd1f2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bd1f2e"]])

export default __exports__